<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Gestión de Empresas</h2>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <button class="btn btn-primary" (click)="abrirModoCreacionEmpresa()">
        <i class="fas fa-plus me-1"></i> Agregar Empresa
      </button>
    </div>

    <app-empresa-modal
      (empresaGuardada)="handleEmpresaGuardada()"
      (empresaActualizada)="handleEmpresaActualizada()"
      (empresaEliminada)="handleEmpresaEliminada()"
    >
    </app-empresa-modal>

    <div class="table-responsive">
      <table
        id="tablaEmpresas"
        class="table table-striped table-bordered w-100"
      >
        <thead>
          <tr></tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
